// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__ep+qr","avatar__image":"Avatar_avatar__image__9Ro5y","avatar__loadInput":"Avatar_avatar__loadInput__x8AzF"};